import { get, post } from "./request";
import { buildApiUrl, API_CONFIG } from "./config";
import type { ApiResponse, FavoriteItem } from "./types";

// 收藏相关API
export const favoriteApi = {
  /**
   * 收藏帖子
   * @param tid - 帖子ID
   * @param game_id - 游戏ID
   * @returns Promise<ApiResponse>
   */
  add: (tid: number, game_id: number): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.FAVORITE,
      API_CONFIG.ACTIONS.ADD,
      {
        tid,
        game_id,
      }
    );
    return get<ApiResponse>(url);
  },

  /**
   * 取消收藏帖子
   * @param tid - 帖子ID
   * @param game_id - 游戏ID
   * @returns Promise<ApiResponse>
   */
  remove: (tid: number, game_id: number): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.FAVORITE,
      API_CONFIG.ACTIONS.REMOVE,
      {
        tid,
        game_id,
      }
    );
    return get<ApiResponse>(url);
  },

  /**
   * 获取玩家收藏帖子的列表
   * @returns Promise<ApiResponse<FavoriteItem[]>>
   */
  getList: (
    uid: number,
    page: number = 1,
    page_size: number = 10,
    game_id: number
  ): Promise<ApiResponse<FavoriteItem[]>> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.FAVORITE,
      API_CONFIG.ACTIONS.LIST,
      {
        uid,
        page,
        page_size,
        game_id,
      }
    );
    return get<ApiResponse<FavoriteItem[]>>(url);
  },
};
